import { QueryClient } from '@tanstack/react-query';

const defaultQueryConfig = { staleTime: 60000 };

export const queryClient = new QueryClient({
    defaultOptions: { queries: defaultQueryConfig }
});

export const getQueryKeyBase = (baseKey, ...args) => {
    if (!args) {
        return [baseKey];
    }
    return [baseKey, ...args];
};

export const QUERY_KEYS = {
    CONCEPT_DETERMINATION_METHODS: 'concept-determination-methods',
    CONCEPT_DETERMINATION_METHOD: 'concept-determination-method'
};

export const MUTATION_KEYS = {
    CONCEPT_DETERMINATION_METHOD: 'concept-determination-method'
};
